var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNfts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.101 32.809L5.47098 37.979C2.98098 40.769 3.21098 45.059 6.00098 47.559L22.661 62.479M94.521 63.019L89.661 68.449L76.971 43.889V38.199L94.001 53.449C96.791 55.949 97.021 60.229 94.521 63.019ZM58.941 8.97898H44.341L42.651 7.46898L48.861 4.25898C52.191 2.53898 56.281 3.84898 58.001 7.16898L58.941 8.97898ZM57.211 93.419L50.771 96.739C47.441 98.459 43.351 97.159 41.631 93.829L40.691 92.019H55.651L57.211 93.419Z",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2409 7.09901L44.3409 8.97901H31.4409L32.6609 7.61901C35.1609 4.82901 39.4509 4.59901 42.2409 7.09901ZM55.6509 92.019H68.5609L67.341 93.379C64.841 96.169 60.5509 96.409 57.7609 93.909L55.6509 92.019ZM12.6609 22.969L22.6609 17.799V57.109L9.74095 32.099C8.02095 28.779 9.33095 24.689 12.6609 22.969ZM86.9809 78.039L76.9709 83.209V43.889L89.8909 68.899C91.6109 72.229 90.3109 76.319 86.9809 78.039Z",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.975 15.762V85.241C76.975 88.987 73.938 92.023 70.193 92.023H29.442C25.696 92.023 22.66 88.986 22.66 85.241V15.762C22.66 12.016 25.697 8.97998 29.442 8.97998H70.193C73.939 8.97998 76.975 12.016 76.975 15.762Z",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.593 20.628H68.041",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.041 80.376H31.593",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.593 57.206V43.796C31.593 41.435 32.853 39.252 34.898 38.072L46.512 31.367C48.557 30.187 51.076 30.187 53.121 31.367L64.736 38.073C66.781 39.254 68.041 41.436 68.041 43.797V57.207C68.041 59.568 66.781 61.751 64.736 62.931L53.122 69.636C51.077 70.816 48.558 70.816 46.513 69.636L34.898 62.93C32.853 61.749 31.593 59.567 31.593 57.206Z",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.602 46.665V54.338L38.58 46.665V54.338",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6 46.665H61.055",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.328 54.338V46.665",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.079 54.338V46.665H51.92",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.079 50.502H51.92",
    stroke: "#67797F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNfts);
export default __webpack_public_path__ + "static/media/no_nfts.5e4b092228bf17889aa4081dff765211.svg";
export { ForwardRef as ReactComponent };